module.exports = __webpack_public_path__ + "public/SiteIcons/goWishIcon.svg?6347aa7b";